import { Field, useFormikContext } from 'formik';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';

export default function StatementOfCircumstances() {
  const form = useFormikContext();

  return (
    <Section title="Owner's Statement of Circumstances">
      <Subheader>Include the following: </Subheader>
      <Field
        InputLabelProps={{ shrink: true }}
        component={MuiValidTextField}
        label="Owner's statement of circumstances and request for relief"
        multiline
        name={`statement`}
        onChange={({ target }) => {
          form.setFieldValue(`statement`, target.value);
        }}
        placeholder="Enter statement here..."
        rows={6}
        type="text"
        variant="outlined"
      />
    </Section>
  );
}
